import { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { generatePath, useNavigate, useParams } from "react-router-dom";
// img
import { useGetFeedbackStepDetailQuery, useSubmitReportMutation } from "store/services/clients/assessmentTreatmentPlan";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { dateFormat, formatString, getAge, getPdfBlob, successMessageToast } from "helpers/common";
import { CLIENT_REPORT_TYPES, GOAL_TRACK_PARAMETERS, INDIVIDUAL_SESSION_REPORT_QUESTIONS } from "config/constants";
import { INDIVIDUAL_SESSION_REPORT } from "config/paths";
import LoadingButton from "components/shared/LoadingButton";
import RenderAnswer, { RenderAnswerByQId } from "components/shared/ReportComponents/AnswerFields/Index";
import SessionOutcomePieChart from "components/shared/ReportComponents/SessionOutcomePieChart";
import { getGoalTrackingPercentage } from "helpers/assessment";
import KhanReportLogo from "components/shared/ReportComponents/KhanReortLogo";
import HeaderPreview from "components/shared/ReportComponents/ReportHeader/Preview";
import { clientListingPath } from "helpers/navigationHelper";
import { REPORT_SUBMITTED_SUCCESS } from "config/messages";
import { IndividualSessionReportPdfDoc } from "components/PDF/Clients/Reports/IndividualSessionReportPdf";
import { useUploadFileMutation } from "store/services/utility";
import GuardianDetailRow from "components/shared/ReportComponents/GuardianDetailRow";
import moment from "moment";
import { store } from "store/store";
import SaveForLaterBtn from "components/shared/ReportComponents/SaveForLaterBtn";

const IndividualSessionReportPreview = () => {

  const isVeteran = store.getState()?.auth?.user?.role_type === "veteran";

  const navigate = useNavigate();
  const chartRefs = useRef([]);
  const { assessmentId, clientId, clientType } = useParams();

  const [isSubmitting, setSubmitting] = useState(false);
  const [isSaveLater, setSaveLater] = useState(false);


  const [submitReport, { isLoading: reportSubmitting }] = useSubmitReportMutation();
  const [uploadFile, { isLoading: uploadingReportPdf }] = useUploadFileMutation();

  const { data, isLoading, isFetching, isError, refetch } = useGetFeedbackStepDetailQuery({ assessmentId, clientId, clientType });
  const assessmentGoals = data?.assesmentData?.reportGoals;
  const assessmentAssignedId = data?.assesment?.id;
  const reportQuestions = data?.assesmentData?.reportQuestions;
  const reportAnswers = data?.assesmentData?.reportAnswers;

  const caseDiscipline = data?.clientPendingCaseload?.clientCaseloadTherapist?.caseDiscipline;
  const caseTherapist = data?.clientPendingCaseload?.clientCaseloadTherapist?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type == "veteran")?.caseTherapist;
  const therapistDetails = { caseDiscipline, caseTherapist }

  useEffect(() => {
    refetch();
  }, [refetch]);

  const handleClickBack = () => {
    navigate(
      generatePath(INDIVIDUAL_SESSION_REPORT, {
        assessmentId,
        clientId,
        clientType
      })
    );
  }

  const handleSubmitReport = async () => {
    try {
      setSubmitting(true);
      const images = await Promise.all(
        chartRefs.current.map(async (ref) => {
          if (ref) {
            return await ref.generateImage();
          }
          return null;
        })
      );

      const doc = (
        <IndividualSessionReportPdfDoc
          data={data}
          images={images}
          clientType={clientType}
        />
      )
      const filename = `Indiviudal Session Report - ${caseDiscipline?.assign_term} - ${moment(new Date()).format("YYYY-MM-DD")}.pdf`
      let pdfFile = await getPdfBlob(doc, false, filename);

      let uploadedFileKey = await uploadFile({ file: pdfFile, acl: "private", fileOriginalFormat: true }).unwrap();

      if (!uploadedFileKey) {
        throw new Error("File not uploaded");
      }

      const payload = {
        assessmentAssignedId,
        data: {
          attachment_key: uploadedFileKey,
          attachment_name: CLIENT_REPORT_TYPES[assessmentId].name,
        },
        clientType
      }

      let response = await submitReport(payload).unwrap();
      setSubmitting(false);
      if (!response?.error) {
        successMessageToast(REPORT_SUBMITTED_SUCCESS)
        navigate(clientListingPath(clientType));
      }
    } catch (err) {
      console.error("Error submitting report", err);
      setSubmitting(false);
    }
  }

  return (
    <>
      <section className="ReportSec py-3 position-relative">
        <Container fluid>
          <Row>
            <Col lg="12" className="my-2">
              <div className="cardCstm p-lg-5 rounded-2 bg-white shadow">
                {isLoading ? (
                  <LoadingIndicator />
                ) : isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {isFetching && <LoadingOverlay />}
                    <HeaderPreview
                      heading={data?.assesment?.report_heading}
                    />
                    <div className="formBody pt-3">
                      <div className="">
                        <div className="py-3">
                          <div
                            className="cardCstm rounded-2 px-3"
                            style={{ background: "#F9F9F9" }}
                          >
                            <Row className="border-bottom p-2">
                              <Col md="6" className="py-2">
                                <div className="d-flex align-items-start gap-10 flex-wrap">
                                  <h6
                                    className="m-0 fw-sbold themeBlue"
                                    style={{ minWidth: 200, fontSize: 14 }}
                                  >
                                    Last Name
                                  </h6>
                                  <p className="m-0 themeBlue">
                                    {data?.lastname}
                                  </p>
                                </div>
                              </Col>
                              <Col md="6" className="py-2">
                                <div className="d-flex align-items-start gap-10 flex-wrap">
                                  <h6
                                    className="m-0 fw-sbold themeBlue"
                                    style={{ minWidth: 200, fontSize: 14 }}
                                  >
                                    First Name
                                  </h6>
                                  <p className="m-0 themeBlue">
                                    {data?.firstname}
                                  </p>
                                </div>
                              </Col>
                            </Row>
                            <Row className="border-bottom p-2">
                              <Col md="6" className="py-2">
                                <div className="d-flex align-items-start gap-10 flex-wrap">
                                  <h6
                                    className="m-0 fw-sbold themeBlue"
                                    style={{ minWidth: 200, fontSize: 14 }}
                                  >
                                    Date of Birth
                                  </h6>
                                  <p className="m-0 themeBlue">
                                    {dateFormat(data?.client_detail?.dob)}
                                  </p>
                                </div>
                              </Col>
                              <Col md="6" className="py-2">
                                <div className="d-flex align-items-start gap-10 flex-wrap">
                                  <h6
                                    className="m-0 fw-sbold themeBlue"
                                    style={{ minWidth: 200, fontSize: 14 }}
                                  >
                                    Age:
                                  </h6>
                                  <p className="m-0 themeBlue">
                                    {getAge(data?.client_detail?.dob)}
                                  </p>
                                </div>
                              </Col>
                            </Row>
                            {clientType == "school" && <Row className="border-bottom p-2">
                              <Col md="6" className="py-2">
                                <div className="d-flex align-items-start gap-10 flex-wrap">
                                  <h6
                                    className="m-0 fw-sbold themeBlue"
                                    style={{ minWidth: 200, fontSize: 14 }}
                                  >
                                    Grade
                                  </h6>
                                  <p className="m-0 themeBlue">
                                    {data?.client_detail?.grade}
                                  </p>
                                </div>
                              </Col>
                              <Col md="6" className="py-2">
                                <div className="d-flex align-items-start gap-10 flex-wrap">
                                  <h6
                                    className="m-0 fw-sbold themeBlue"
                                    style={{ minWidth: 200, fontSize: 14 }}
                                  >
                                    School:
                                  </h6>
                                  <p className="m-0 themeBlue">
                                    {data?.client_detail?.client_school_detail?.client_school?.name}
                                  </p>
                                </div>
                              </Col>
                            </Row>}
                            {data?.client_detail?.client_guardian_mapping?.length > 0 &&
                              data?.client_detail?.client_guardian_mapping?.map(
                                (guardian, index) => {
                                  const slug = guardian?.client_guardian?.client_role?.slug;
                                  if (slug !== (clientType == "school" ? "teacher" : "parent")) {
                                    return null;
                                  }

                                  return (
                                    <GuardianDetailRow
                                      index={index}
                                      guardian={guardian}
                                      slug={slug}
                                    />
                                  );
                                }
                              )}
                            <Row className="border-bottom p-2">
                              <Col md="6" className="py-2">
                                <div className="d-flex align-items-start gap-10 flex-wrap">
                                  <h6
                                    className="m-0 fw-sbold themeBlue"
                                    style={{ minWidth: 200, fontSize: 14 }}
                                  >
                                    Report Date
                                  </h6>
                                  <p className="m-0 themeBlue">
                                    {dateFormat(moment())}
                                  </p>
                                </div>
                              </Col>
                            </Row>
                            <Row className="border-bottom p-2">
                              <Col md="6" className="py-2">
                                <div className=" d-flex align-items-center">
                                  <p className="m-0 text-muted mx-1">
                                    {formatString(data?.assesment?.assesment_location)}
                                  </p>
                                </div>
                              </Col>
                              {/* <Col md="6" className="py-2">
                                <div className=" d-flex align-items-center">
                                  <p className="m-0 text-muted mx-1">Present</p>
                                </div>
                              </Col> */}
                            </Row>
                          </div>
                        </div>
                        {reportQuestions?.length > 0 &&
                          reportQuestions?.map((question, index) => {
                            if (
                              [
                                INDIVIDUAL_SESSION_REPORT_QUESTIONS.greeting,
                              ].includes(question.id)
                            ) {
                              return null;
                            }
                            let foundAnswer = reportAnswers?.length && reportAnswers.find(answer => answer.question_id === question.id);
                            return (
                              <RenderAnswer
                                key={index}
                                question={question}
                                answer={foundAnswer}
                              />
                            );
                          })
                        }
                        <div className="py-3">
                          <div className="d-flex align-items-center gap-10 mt-3">
                            <h6 className="m-0 fw-sbold themeBlue pb-1">
                              Discipline
                            </h6>
                            <input
                              type="text"
                              value={
                                therapistDetails?.caseDiscipline
                                  ?.name
                              }
                              className="form-control text-dark fw-bold text-center"
                              style={{
                                background: "#e9e9e9",
                                maxWidth: 220,
                              }}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="py-3">
                          <div className="py-3">
                            <div
                              className="cardCstm rounded-3 p-3"
                              style={{ background: "#FBFBE6" }}
                            >
                              {assessmentGoals?.length > 0 &&
                                assessmentGoals?.map((goal, index) => (
                                  <Row>
                                    <Col md="7" className="my-2">
                                      <div className="top d-flex align-items-start">
                                        <h5 className="m-0 fw-bold themeBlue">
                                          {index + 1}.
                                        </h5>
                                        <div className="px-3">
                                          <h5 className="m-0 pb-1 fw-sbold themeBlue border-bottom">
                                            Area
                                          </h5>
                                          <p className="m-0 themeBlue pt-1">
                                            {goal?.assesmentGoalDisciplineArea?.name}
                                          </p>
                                        </div>
                                        <div className="px-3">
                                          <h5 className="m-0 pb-1 fw-sbold themeBlue border-bottom">
                                            Goal
                                          </h5>
                                          <p className="m-0 themeBlue pt-1">
                                            {goal?.assesmentGoalDetail?.title}
                                          </p>
                                        </div>
                                        <div className="px-3">
                                          <h5 className="m-0 pb-1 fw-sbold themeBlue border-bottom">
                                            Context
                                          </h5>
                                          <p className="m-0 themeBlue pt-1">
                                            {goal?.assesmentGoalContext?.context}
                                          </p>
                                        </div>
                                      </div>
                                      <div className="bottom pt-4">
                                        <h6 className="m-0 fw-bold themeBlue mb-3">
                                          Goal Details
                                        </h6>
                                        <div
                                          className="px-lg-4 p-3 rounded-3"
                                          style={{ background: "#F2F3DA" }}
                                        >
                                          <p className="m-0 themeBlue">
                                            {goal?.goal_description}
                                          </p>
                                        </div>
                                      </div>
                                      <div className="bottom pt-4">
                                        <h5 className="m-0 fw-bold themeBlue mb-3">
                                          Goal Review
                                        </h5>
                                        <div
                                          className="px-lg-4 p-3 rounded-3"
                                          style={{ background: "#F2F3DA" }}
                                        >
                                          <p className="m-0 themeBlue">
                                            {goal?.goal_notes}
                                          </p>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col md="5" className="my-2">
                                      <div
                                        className="innerCard p-3 rounded-4"
                                        style={{ background: "#E8F2E0" }}
                                      >
                                        <div className="px-lg-4">
                                          <div className="py-2">
                                            <SessionOutcomePieChart
                                              key={index}
                                              ref={(el) => (chartRefs.current[index] = el)}
                                              trackingData={
                                                goal?.goalTracking
                                              }
                                            />
                                          </div>
                                          {goal?.goalTracking
                                            ?.length > 0 ? (
                                            <ul className="list-unstyled ps-0 mb-0">
                                              {Object.entries(
                                                GOAL_TRACK_PARAMETERS
                                              )?.map(
                                                (
                                                  [param, label],
                                                  index
                                                ) => {
                                                  let parameterPercentage =
                                                    getGoalTrackingPercentage(
                                                      param,
                                                      goal?.goalTracking
                                                    );
                                                  return (
                                                    <li
                                                      key={index}
                                                      className="py-1 d-flex align-items-center justify-content-between gap-10"
                                                    >
                                                      <p className="m-0">
                                                        <span className="fw-sbold">
                                                          {param}
                                                        </span>{" "}
                                                        - {label}
                                                      </p>
                                                      <p className="m-0 fw-bold">
                                                        <span className="px-2">
                                                          {
                                                            parameterPercentage
                                                          }
                                                        </span>
                                                        %
                                                      </p>
                                                    </li>
                                                  );
                                                }
                                              )}
                                            </ul>
                                          ) : (
                                            <p>
                                              Goal not tracked yet
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                ))
                              }
                            </div>
                          </div>
                        </div>
                        <RenderAnswerByQId
                          questionId={INDIVIDUAL_SESSION_REPORT_QUESTIONS.greeting}
                          reportQuestions={reportQuestions}
                          reportAnswers={reportAnswers}
                          showQuestion={false}
                        />
                      </div>
                      <div className="py-3">
                        <img
                          src={
                            therapistDetails?.caseTherapist
                              ?.therapist_detail?.signature_img
                          }
                          style={{ height: 70 }}
                          alt=""
                          className="img-fluid object-fit-contain"
                        />
                        <p className="m-0 fw-sbold" style={{ whiteSpace: "pre-wrap" }}>
                          {therapistDetails?.caseTherapist?.therapist_detail?.email_signature}
                        </p>
                      </div>
                      <div className="py-3">
                        <KhanReportLogo />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </Col>
            <Col lg="12" className="my-2 d-flex gap-10">
              <Button
                style={{
                  background: "rgb(69, 163, 165)",
                  borderColor: "rgb(69, 163, 165)",
                }}
                onClick={handleClickBack}
                disabled={!!isSubmitting || !!isSaveLater}
                className="d-flex align-items-center justify-content-center commonBtn fw-sbold"
              >
                Back
              </Button>
              {
                isVeteran && (
                  <SaveForLaterBtn
                    assessmentAssignedId={assessmentAssignedId}
                    clientType={clientType}
                    isLoading={!!isSubmitting}
                    setSaveLater={setSaveLater}
                  />
                )
              }
              {
                isVeteran && <LoadingButton
                  className="d-flex align-items-center justify-content-center commonBtn"
                  onClick={handleSubmitReport}
                  isLoading={isSubmitting}
                  disabled={!!isSaveLater}
                >
                  Submit
                </LoadingButton>
              }
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default IndividualSessionReportPreview;
